/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import axios from "axios";
import {
  baseApiV2,
  connectorApi,
  connectorDetailsApi,
} from "../../constants/Presets";

// function that makes the api request and returns a Promise for response
export function FetchAnalytics(payload) {
  const url = payload
    ? `${connectorDetailsApi}?company_id=${payload}`
    : connectorDetailsApi;
  return axios.get(url);
}
export function FetchAAnalytic(id) {
  return axios.get(`${connectorApi}/${id}`);
}
export function FetchAnalyticRestrictionList(id) {
  return axios.get(`${baseApiV2}connectorRestrictions?companyId=${id}`);
}
export function CreateAnalyticRestriction(payload) {
  return axios.post(`${baseApiV2}connectorRestrictions`, payload);
}
export function DeleteAnalyticRestriction(payload) {
  return axios.delete(`${baseApiV2}connectorRestrictions`, { data: payload });
}
